import React from "react";
import { Leaf, ShieldCheck, Heart } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EcoSealCommitment() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="eco-seal-commitment" className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-32">
      {}
      <div className="absolute inset-0 pointer-events-none select-none overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] opacity-[0.03] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570251/img/tropical_leaf_watermark.png)] bg-contain bg-center bg-no-repeat rotate-12 mix-blend-overlay blur-sm" />
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-background via-transparent to-background opacity-80" />
      </div>

      <div ref={ref} className={`relative z-10 container mx-auto px-4 max-w-4xl text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        {}
        <div className="flex justify-center mb-8">
          <Badge variant="outline" className="px-6 py-2 text-sm md:text-base font-bold tracking-wider border-chart-3/30 text-chart-3 bg-chart-3/10 shadow-[0_0_30px_-5px_var(--color-chart-3)] backdrop-blur-sm rounded-full uppercase">
            <Leaf className="w-4 h-4 mr-2 fill-current" />
            100% Eco-Safe
          </Badge>
        </div>

        {}
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 text-foreground drop-shadow-lg">
          Safe for Your Family, <br className="hidden md:block" />
          <span className="text-primary">Crucial for Our Island.</span>
        </h2>

        {}
        <p className="text-lg md:text-xl text-muted-foreground mb-10 leading-relaxed max-w-2xl mx-auto">
          At Island Seals, we believe that protecting your home shouldn't come at
          the cost of our environment. Our industry-leading sealants are
          engineered to be tough on moisture but gentle on nature, ensuring a
          durable shield for your surfaces while preserving the natural beauty
          of our community.
        </p>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12 text-left md:text-center">
          <div className="flex flex-col md:items-center p-4 rounded-lg hover:bg-white/5 transition-colors duration-300">
            <div className="mb-4 p-3 rounded-full bg-chart-3/10 text-chart-3 w-fit">
              <ShieldCheck className="w-6 h-6" />
            </div>
            <h3 className="text-lg font-semibold mb-2 text-foreground">
              Non-Toxic Protection
            </h3>
            <p className="text-sm text-muted-foreground">
              Safe for pets, children, and plants immediately after curing. No
              harsh chemicals leaching into your soil.
            </p>
          </div>

          <div className="flex flex-col md:items-center p-4 rounded-lg hover:bg-white/5 transition-colors duration-300">
            <div className="mb-4 p-3 rounded-full bg-primary/10 text-primary w-fit">
              <Leaf className="w-6 h-6" />
            </div>
            <h3 className="text-lg font-semibold mb-2 text-foreground">
              Biodegradable Formulas
            </h3>
            <p className="text-sm text-muted-foreground">
              Our sealants break down naturally over extremely long periods
              without leaving micro-plastic residue.
            </p>
          </div>

          <div className="flex flex-col md:items-center p-4 rounded-lg hover:bg-white/5 transition-colors duration-300">
            <div className="mb-4 p-3 rounded-full bg-chart-5/10 text-chart-5 w-fit">
              <Heart className="w-6 h-6" />
            </div>
            <h3 className="text-lg font-semibold mb-2 text-foreground">
              Island Preserving
            </h3>
            <p className="text-sm text-muted-foreground">
              Designed specifically to withstand our local climate while
              protecting our precious groundwater sources.
            </p>
          </div>
        </div>

        {}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button asChild size="lg" className="rounded-full px-8 text-base">
            <Link to="/RequestQuotePage">Get a free Quote</Link>
          </Button>
          <Button asChild variant="ghost" size="lg" className="rounded-full px-8 text-base hover:bg-white/10">
            <Link to="/ProjectGalleryPage">View Our Work</Link>
          </Button>
        </div>
      </div>
    </section>;
}